import selectIdTypeValidation from "./selectIdTypeValidation";
import stateOwnedEnterpriseValidation from "./stateOwnedEnterpriseValidation";
import beneficialOwnershipValidation from "./beneficialOwnershipValidation";
import identificationValidation from "components/PLCTABS/CompanyOfficialsTab/AssembledCompanyOfficialForms/commonValidationSchema/identificationValidation";
import residentialDetailsValidation from "components/PLCTABS/CompanyOfficialsTab/AssembledCompanyOfficialForms/commonValidationSchema/residentialDetailsValidation";
import uploadDocumentsValidation from "components/PLCTABS/CompanyOfficialsTab/AssembledCompanyOfficialForms/commonValidationSchema/uploadDocumentsValidation";

/**
 * This returns an object composed of conditional initial values using `yup` schema
 * for identification, residential details, share allocation table and upload documents forms
 * of `Shareholder` and `Director Shareholder` officials.
 *
 * @param {string} idType The idType of the current official e.g `"Kenyan Citizen"`.
 * @param {string} isNonResident Conditional string value `'No' || 'Yes` of the current official.
 * @param {array} documentData The array of objects related to file uploads.
 * @param {object} beneficialOwnershipForm - Object containing fields related to BO form.
 * @param {number} allottedShares - Allotted shares.
 * @param {number} allottedVotingRights - Alloted voting rights.
 * @return {object} This returns object containing initial values.
 * @example
 *  {}
 */
const getInitialValues = ({
  idType,
  isNonResident = null,
  documentData,
  beneficialOwnershipForm,
  allottedShares,
  allottedVotingRights,
  corporateIdType,
}) => {
  if (corporateIdType === "State Owned Enterprise") {
    return stateOwnedEnterpriseValidation().schemaInitialValues;
  }

  return {
    ...selectIdTypeValidation().schemaInitialValues,
    ...identificationValidation(idType).schemaInitialValues,
    ...residentialDetailsValidation({ idType, isNonResident })
      .schemaInitialValues,
    ...uploadDocumentsValidation(documentData).schemaInitialValues,
    ...beneficialOwnershipValidation(
      idType,
      beneficialOwnershipForm,
      allottedShares,
      allottedVotingRights
    ).schemaInitialValues,
    ...stateOwnedEnterpriseValidation().schemaInitialValues,
  };
};

export default getInitialValues;
